module.exports = __webpack_public_path__ + "img/D201411_4.406dc834.jpg";